/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable func-names */
export const register = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
      navigator.serviceWorker
        .register('/sw.js')
        .then(function(registration) {
          // Registration was successful
          // console.log('ServiceWorker registration successful with scope: ', registration.scope);
        })
        .catch(function(err) {
          // registration failed :(
          // console.log('ServiceWorker registration failed: ', err);
        });
    });
  }
};
